
module.exports = {
	SET_GENERIC_ERROR: 'SET_GENERIC_ERROR',
    CLEAR_GENERIC_ERROR: 'CLEAR_GENERIC_ERROR',
    SET_GENERIC_RESPONSE_ERROR: 'SET_GENERIC_RESPONSE_ERROR',
    CLEAR_GENERIC_RESPONSE_ERROR: 'CLEAR_GENERIC_RESPONSE_ERROR'
};



// WEBPACK FOOTER //
// ./src/common/modules/common/constants.js